export const submitEvaluation = async ({ refId, answers }) => {
  const res = await fetch(`https://petros-global.com/ems/backend/evaluation/submit.php`, {
    cache: "no-store",
    headers: {
      "Authorization": "Ok"
    },
    method: "POST",
    body: JSON.stringify({
      variables: {
        refId,
        answers,
      },
    }),
  });

  return res;
};

export const fetchCertByRef = async (refLink) => {
  const res = await fetch("https://petros-global.com/ems/backend/evaluation/certByRefId.php?refId=" + refLink, {
    cache: "no-store",
    headers: {
      "Authorization": "Ok"
    },
  });

  const json = await res.json();

  return json;
}

export const fetchResults = async (eventId) => {
  const res = await fetch("https://petros-global.com/ems/backend/evaluation/getResults.php?eventId=" + eventId, {
    cache: "no-store",
    headers: {
      "Authorization": "Ok"
    },
  });

  const json = await res.json();

  return json;
}